import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="mx-auto max-w-4xl px-6 py-12 md:px-12">
      <h1 className="animate-fade-in mb-8 text-4xl font-bold md:text-5xl">Privacy Policy</h1>

      <div className="animate-fade-in space-y-8" style={{ animationDelay: '200ms' }}>
        <section>
          <h2 className="mb-4 text-2xl font-bold">Introduction</h2>
          <p className="mb-4 text-lg text-gray-400">
            At hebe, we take your privacy seriously. This Privacy Policy explains how we collect,
            use, and protect your personal information when you use our services.
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Information We Collect</h2>
          <ul className="list-inside list-disc space-y-2 text-lg text-gray-400">
            <li>Email addresses for waitlist and communications</li>
            <li>Usage data to improve our services</li>
            <li>Information you choose to share with hebe</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">How We Use Your Information</h2>
          <ul className="list-inside list-disc space-y-2 text-lg text-gray-400">
            <li>To provide and improve our services</li>
            <li>To communicate updates and announcements</li>
            <li>To ensure security and prevent fraud</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Data Protection</h2>
          <p className="mb-4 text-lg text-gray-400">
            We implement robust security measures to protect your personal information from
            unauthorized access, alteration, or disclosure.
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Your Rights</h2>
          <p className="mb-4 text-lg text-gray-400">You have the right to:</p>
          <ul className="list-inside list-disc space-y-2 text-lg text-gray-400">
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Object to data processing</li>
            <li>Data portability</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Contact Us</h2>
          <p className="mb-4 text-lg text-gray-400">
            If you have any questions about our Privacy Policy, please contact us at{' '}
            <a href="mailto:privacy@ohhebe.us" className="text-accent hover:opacity-80">
              privacy@ohhebe.us
            </a>
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Related Policies</h2>
          <p className="mb-4 text-lg text-gray-400">
            Please also review our{' '}
            <Link to="/cookies" className="text-accent hover:opacity-80">
              Cookie Policy
            </Link>{' '}
            and{' '}
            <Link to="/trust" className="text-accent hover:opacity-80">
              Trust Center
            </Link>{' '}
            for more information about how we handle your data.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
